module.exports = __webpack_public_path__ + "media/images/guide-2-529864f99337ca36b2fa077935965d32.png";